/**
 * The org's look, saved with the org (platform-core internal/orgs/branding.go; the 2026-10-06 next-phase plan, step 3):
 *
 *   GET /v1/platform/branding   the active org's stored theme blob, and its vendor-origin marker; {} for an org that
 *                               saved none. Any member.
 *   PUT /v1/platform/branding   {theme} replaces the blob. Org admins (403 otherwise). The marker is never written.
 *
 * The blob is read through lib/theme/org-look orgLookOf, so only the org's look is ever taken from it.
 */
import { api } from "@/lib/api-client";
import type { OrgLook } from "@/lib/theme/org-look";

export interface OrgBranding {
  theme: unknown;
  vendor_org_id: string | null;
}

export const ORG_BRANDING_KEY = ["org-branding"] as const;

export const brandingApi = {
  get: () => api.get<OrgBranding>("/v1/platform/branding"),
  put: (look: OrgLook) => api.put<OrgBranding>("/v1/platform/branding", { theme: look }),
};
